import NextLink from "next/link";

// mui
import Link, { LinkProps } from "@mui/material/Link";

// Linkを共通化するにあたって、二パターン用意した。
// 1. 普通のLink(disableは可能)
// 2. permissionによって表示、非表示が変わるLink(disableという概念がない。表示されなくなるので)
//   (2はPermissionComponentというファイル内にpermisseion系をまとめておいている)
//   1と2で受け取る引数が微妙に変わるので、BaseLinkを定義して、1と2でそれを呼び出すような実装にした。

// - Linkタグの使われ方として二パターンある。
//   - onClickでサイドのinfoBarを出したりする
//   - hrefで普通に画面遷移させる
//   onclickはあったりなかったりするので、それの有無でcomponentを分岐させてる。
// - onClickの際にもloadingが走るので、UXのためにcomponentを分離してloadingを不要に走らせないようにした。
export const BaseLink = (props: LinkProps): React.JSX.Element => {
  const { href, onClick, children, ...others } = props;

  const renderWithoutOnClick = (): React.JSX.Element => {
    if (!href) return <></>;

    return (
      <Link component={NextLink} href={href} underline="none" {...others}>
        {children}
      </Link>
    );
  };

  const renderWithOnClick = (): React.JSX.Element => {
    if (!onClick) return <></>;

    return (
      <Link underline="none" onClick={onClick} {...others}>
        {children}
      </Link>
    );
  };

  return onClick ? renderWithOnClick() : renderWithoutOnClick();
};

type NormalLinkType = {
  disabled?: boolean;
};

// disabledのリンク
const NitoelLink = (props: LinkProps & NormalLinkType): React.JSX.Element => {
  const { disabled, children, ...others } = props;

  if (disabled) {
    return <>{children}</>;
  }

  return <BaseLink {...others}>{children}</BaseLink>;
};

export default NitoelLink;
